import { createCrudProp } from '../utils/crud-prop'
import { sortByTimeIfExists } from '../utils/sort-by'

const waveProps = createCrudProp({
  rootKey: 'waves',
  idPrefix: 'wv',
  requiredProps: ['name', 'time', 'type', 'svg'],
  sortFn: sortByTimeIfExists,
})

/**
 * @param {WaveformCaptureBase} props The wave properties
 * @returns {any} The changes to apply to the case.
 */
export const actionAddWave = props => waveProps.actionAdd(props)

/**
 * @param {string} id The wave ID
 * @returns {any} The changes to apply to the case.
 */
export const actionRemoveWave = waveProps.actionRemove

/**
 * @param {string} id The wave ID
 * @param {{ notes: string }} notes The updates to apply to the wave
 * @returns {any} The changes to apply to the case.
 */
export const actionUpdateWave = (id, { notes }) =>
  waveProps.actionUpdate(id, { notes })

/** @returns {WaveformCapture[]} The waveform captures sorted by time */
export const selectWaves = waveProps.select

/**
 * @param {any} caseData
 * @returns {{
 *   [id: string]: WaveformCaptureBase
 * }}
 */
export const selectWavesRaw = waveProps.selectRaw
